/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseTemplateDto } from '../../models/base-template-dto';
import { CreateTemplateRequest } from '../../models/create-template-request';

export interface CreateTemplate$Params {
      body: CreateTemplateRequest
}

export function createTemplate(http: HttpClient, rootUrl: string, params: CreateTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, createTemplate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseTemplateDto>;
    })
  );
}

createTemplate.PATH = '/v0/templates';
